import React from 'react'

const Thumbnail = ({ thumbnail, useSmall, isDecorative }) => {
  let alt;
  let url;

  if (useSmall === true && thumbnail.thumbnails.small != null){
    url = thumbnail.thumbnails.small.url;
    alt = thumbnail.thumbnails.small.alt == null ? "" :  thumbnail.thumbnails.small.alt;
  }
  else {
    if(thumbnail.thumbnails.horizontal.alt !== null){
      url = thumbnail.thumbnails.horizontal.url;
      alt = thumbnail.thumbnails.horizontal.alt == null ? "" : thumbnail.thumbnails.horizontal.alt;
    }
    else {
      url = thumbnail.url;
      alt = thumbnail.alt == null ? "" : thumbnail.alt;
    }
    
  }
  if(isDecorative === true){
    alt = "";
  }

    return (
      <img src={url} alt={alt} className="mr-3 float-left d-none d-sm-block"/>
    )
 }

export default Thumbnail;